import { render, staticRenderFns } from "./e-buy-num-product.vue?vue&type=template&id=663d322c&scoped=true"
import script from "./e-buy-num-product.vue?vue&type=script&lang=js"
export * from "./e-buy-num-product.vue?vue&type=script&lang=js"
import style0 from "./e-buy-num-product.vue?vue&type=style&index=0&id=663d322c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d322c",
  null
  
)

export default component.exports